import img from './img';
import audio from './audio';
import gameData from './gameData.config.js';

var config = {
  author: 'TR',
  engine: 'TestWithPoints',
  title: [
    {
      text: 'Kliknij w puste okienko, aby ustawić w nim kursor. Napisz w okienku literę, która pojawi się na ekranie. Podczas pisania trzymaj wciśnięty prawy klawisz Alt.',
      audio: 'games/page023_game1/audio/z23c1.mp3',
    },
  ],
  gameConfig: gameData,
  checkGameSound: {
    positive: 'games/page023_game1/audio/z23c1-brawo.mp3',
    negative: 'games/page023_game1/audio/z23c1-jeszcze-raz.mp3',
  },
  checkGameText: {
    positive: 'Ćwiczenie zostało wykonane. Brawo!',
    negative: 'Spróbuj wykonać to ćwiczenie jeszcze raz.',
  },
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

// console.log( 'config', config );
export default config;
